import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PencilSquareIcon } from '@heroicons/react/24/outline';

import { routeToPage } from 'support/helpers/navigation/navigation';
import { MessageV2DTO, TransactionsRoutes } from 'support/types';

import { ActionConfig } from '../components/types';

export const useEditFromReviewAction = (message: MessageV2DTO): ActionConfig => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return {
    label: t('webedi:viewDocument.editCTA'),
    analyticsId: 'webedi:header-edit-from-review',
    LeftIcon: PencilSquareIcon,
    onClick: () => {
      navigate(routeToPage(TransactionsRoutes.edit, { id: message.id }), {
        state: { keepBreadcrumbs: true },
      });
    },
  };
};
